import { loadFromLocalStorage } from '../../common/onboarding/handleLocalStorage';
import { getCurrentDate } from '../../common/utils/dateUtil';

const CONTRACT_CHANGES_BOTTOM_SHEET_RELEASE_DATE = new Date('2026-08-01T00:00:00+02:00');
export const CONTRACT_CHANGES_BOTTOM_SHEET_FORCE_ENABLED_STORAGE_KEY = 'contract-changes-bottom-sheet-force-enabled';

export function isContractChangesBottomSheetEnabled(now = getCurrentDate()) {
    return (
        loadFromLocalStorage(CONTRACT_CHANGES_BOTTOM_SHEET_FORCE_ENABLED_STORAGE_KEY) === true ||
        now >= CONTRACT_CHANGES_BOTTOM_SHEET_RELEASE_DATE
    );
}
